import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

const EMAIL_RECEIPT_URL = `${MOKA_GOAUTH_SERVICE}/api/v1/email_receipt`;

type EmailReceiptPayload = {
  customerEmail: string;
  paymentId: number;
  paymentUuid: string;
  resendEmail: boolean;
};

async function sendEmailReceipt({ customerEmail, paymentId, paymentUuid, resendEmail }: EmailReceiptPayload): Promise<{ message: string }> {
  const { data } = await axios.post(
    EMAIL_RECEIPT_URL,
    {
      customer_email: customerEmail,
      payment_id: paymentId,
      payment_uuid: paymentUuid,
      resend_email: resendEmail,
    },
    { withCredentials: true },
  );

  return data;
}

export { EMAIL_RECEIPT_URL, sendEmailReceipt };
